const crypto = window.crypto || window.msCrypto;

export const RandomId = (length) => {
  const randomBytes = new Uint8Array(length);
  crypto.getRandomValues(randomBytes);
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let randomString = "";
  for (let i = 0; i < length; i++) {
    randomString += possible.charAt(randomBytes[i] % possible.length);
  }
  const timestamp = Date.now();
  return randomString + timestamp;
};
export const GenerateID = (customer_id, letter, index_) => {
  if (!customer_id || !letter || !index_)
    return alert("Missing field for generating ID");
  // console.log(customer_id, letter, index_)
  if (typeof index_ != "object") {
    // console.log(typeof(index_))
    return alert("Index_ format error");
  }
  if (index_.length === 0) return `${customer_id}-${letter}${String(1)}`;
  const indexes = index_.map((e) => {
    const splitted = e.split(letter);
    const index = splitted[splitted.length - 1];
    return Number(index);
  });
  const max_index = Math.max(...indexes);
  return `${customer_id}-${letter}${String(max_index + 1)}`;
};
// export const RandomId = (length) => {
//   const randomBytes = crypto.randomBytes(Math.ceil(length / 2));
//   const randomString = randomBytes.toString('hex').slice(0, length);
//   const timestamp = Date.now().toString();
//   console.log(randomString);
//   console.log('Ejecutadoooooo')
//   return randomString + timestamp;
// }
